export default __webpack_public_path__ + "static/media/deactivate.aeff1a2e.svg";